// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Airspace } from './Airspace';
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class ShowAirspacesRequest implements IShowAirspacesRequest {
    airspaces!: Airspace[];

    constructor(data?: IShowAirspacesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["airspaces"])) {
                this.airspaces = [] as any;
                for (let item of _data["airspaces"])
                    this.airspaces!.push(Airspace.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShowAirspacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowAirspacesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.airspaces)) {
            data["airspaces"] = [];
            for (let item of this.airspaces)
                data["airspaces"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IShowAirspacesRequest {
    airspaces: Airspace[];
}